import React from "react";
import { IBlock } from "~/utils/interface";
import {
  SliderAuthors,
  SliderBooks,
  SliderTopReadsBooks,
  SliderTropes,
} from "~/components";

interface IBooks {
  blocks: IBlock[];
}

const Books = React.memo(({ blocks }: IBooks) => {
  return (
    <section className="max-md:mt-0 mt-[-60px] books">
      <div className="container">
        {blocks?.map((block, index) => {
          const blockType = block.type;

          return (
            <div
              className="max-md:mb-8 mb-12 last:mb-0 books__items"
              key={`block_${block.index}_${blockType}_${index}`}
            >
              <h4 className="max-md:text-[19px] max-md:leading-[26px] font-extrabold leading-[38px] text-[28px] text-white mb-4">
                {blockType === "tropes"
                  ? "Tropes"
                  : blockType === "authors"
                    ? "Meet our Authors"
                    : block.title}
              </h4>
              {block.title === "Top Reads" ? (
                <SliderTopReadsBooks books={block.books} />
              ) : blockType === "books" ? (
                <SliderBooks
                  slidesToShow={block.title === "Free Incredible Reads" ? 6 : 7}
                  books={block.books}
                  key={`slider_${block.title}`}
                />
              ) : blockType === "tropes" ? (
                <SliderTropes books={block.books} />
              ) : blockType === "authors" && block.authors ? (
                <SliderAuthors authors={block.authors} slidesToShow={11} />
              ) : null}
            </div>
          );
        })}
      </div>
    </section>
  );
});
Books.displayName = "Books";

export default Books;
